/*
import Navigation from '@/components/navigation/Navigation'
import AlertList from '@/components/user/UserAlerts'

export default [
	{
		path: '/users/:user_uid/alerts',
		name: 'AlertList',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AlertList,
			menu: Navigation
		},
		props: {
			default: true,
			menu: true
		}
	}
]
*/

import AppShell from '@/modules/shell/AppShell'
import Navigation from '@/components/navigation/Navigation'
import AlertList from '@/components/user/UserAlerts'
import UserAlertsUnread from '@/components/user/alerts/UserAlertsUnread'
import UserAlertsRead from '@/components/user/alerts/UserAlertsRead'

export default [
	{
		path: '/:user_uid/alerts',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: '/',
				components: {
					default: AlertList,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				},
				children: [
					{
						name: 'AlertList',
						path: '',
						components: {
							default: UserAlertsUnread,
						},
						props: {
							default: true
						}
					},
					{
						name: 'AlertListAll',
						path: 'read/',
						components: {
							default: UserAlertsRead,
						},
						props: {
							default: true
						}
					}
				]
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/alerts.js